"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectHelper = void 0;
const ObjectHelper = () => ({
    compareObjects(obj1, obj2) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        // Verifica se os objetos possuem o mesmo número de chaves
        if (keys1.length !== keys2.length) {
            return false;
        }
        // Verifica se os objetos possuem as mesmas chaves e valores
        for (let key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
        return true;
    },
    areAllFieldsNull(obj) {
        return Object.values(obj).every(value => value === null);
    }
});
exports.ObjectHelper = ObjectHelper;
exports.default = (0, exports.ObjectHelper)();
